<div id="showcase">

<div class="untitled">
	<div class="untitled__slides">
		<div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>@MPPS</span> 
				<!-- <span>BUILDING</span> -->
				<a class="button"  >BUILDING</a>
			</div>
		</div>
		<div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				
				<span>@MPPS</span> 
				<!-- <span>CLASS ROOM</span> -->
				<a class="button" >CLASS ROOM</a>
			</div>
		</div>
		<div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>@MPPS</span> 
				<!-- <span>DANCE</span> -->
				<a class="button"  >DANCE</a>
			</div>
		</div>
		<div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>@MPPS</span> 
				<!-- <span>GROUND</span> -->
				<a class="button"  >GROUND</a>
			</div>
		</div>
        <div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>@MPPS</span> 
				<!-- <span>Calvo</span> -->
				<a class="button"  >KINDERGARTEN</a>
			</div>
		</div>
        <div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>@MPPS</span> 
				<!-- <span>Calvo</span> -->
				<a class="button"  >SCHOOL PLAY</a>
			</div>
		</div>
        <!-- <div class="untitled__slide">
			<div class="untitled__slideBg"></div>
			<div class="untitled__slideContent">
				<span>Mario</span> 
				<span>Calvo</span>
				<a class="button" href="https://unsplash.com/@mariocalvo" >Unsplash Profile</a>
			</div>
		</div> -->
	</div>
	<div class="untitled__shutters"></div>
</div>
</div>